import { Heading, HTMLWrapper, VStack } from "@/storybook-components";
import { useAppSelector } from "@/redux/store/hooks";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";
import { signPrivateEmbedHtml } from "@/helpers/sign-private-embed-html";

const SurveyHeader = () => {
  const { survey, pages, viewResponse } = useAppSelector(
    (state) => state.survey
  );
  const user = useAppSelector((state) => state.user);
  const anonymousUser = useAppSelector((state) => state.anonymousUser);
  const { token } = fetchAuthToken({ user, anonymousUser });

  const { name, description } = survey;
  const signedDescription = signPrivateEmbedHtml(description, token);
  const currentPage = pages.find((page) => page.current);
  let showDescription: boolean = !!description && !viewResponse;

  if (Object.keys(currentPage || {}).length) {
    showDescription = showDescription && !!currentPage?.first;
  }

  return (
    <VStack align="start" gap={4} data-testid="survey-participant-header">
      <Heading
        as="h1"
        fontSize="2.125rem"
        lineHeight="123.5%"
        fontWeight="bold"
        color="gray.800"
        data-testid="survey-participant-survey-title"
      >
        {name}
      </Heading>
      {showDescription && (
        <HTMLWrapper
          fontSize="1.125rem"
          lineHeight="148%"
          fontWeight="normal"
          color="gray.600"
          html={signedDescription ?? description}
          className="ehq-surveyDescription"
          isFullWidth
          data-testid="survey-participant-survey-description"
        />
      )}
    </VStack>
  );
};

export default SurveyHeader;
